import React, { FC } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import styles from "./components.module.scss";

interface ShiftDescriptionContainerProps {
    header?: string;
    address: string;
    from: string;
    to: string;
    rate: number;
    isConfirmModal?: boolean;
    isGuaranteedRate?: boolean;
}

const ShiftDescriptionContainer: FC<ShiftDescriptionContainerProps> = ({
    header,
    address,
    from,
    to,
    rate,
    isConfirmModal,
}) => {
    return (
        <div className={styles.shiftDescriptionBox}>
            <div className={styles.shiftBoxHeader}>{header}</div>
            <div className={styles.shiftBoxLocation}>{address}</div>
            <div className={isConfirmModal ? styles.shiftBoxDate__confirm : styles.shiftBoxDate}>
                <div className={styles.dateTime}>
                    <CalendarTodayIcon className={styles.shiftDateIcon} />
                    {dayjs(from).format('dddd, MMM D')}
                </div>
                <div className={styles.dateTime}>
                    <AccessTimeIcon className={styles.shiftDateIcon} />
                    {`${dayjs(from).format('h:mma')} - ${dayjs(to).format('h:mma')}`}
                </div>
            </div>
            <div className={styles.shiftBoxRateValue}>
                ${rate}<span className={styles.shiftBoxRateValue__hour}>{`/hour`}</span>
            </div>
        </div>
    );
}

export default ShiftDescriptionContainer;